import React from 'react';
import {Stack, styled} from '@mui/material';
import {Body, Icon} from '@lightricks/react-design-system';
import type {IconName} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {SAFE_COLLAB_STATUS} from '../../types/creatorTabTypes';
import type {SafeCollabStatus} from '../../types/creatorTabTypes';
import styles from './SafeCollabBadge.module.scss';

const BADGE_CONFIG: Record<
  SafeCollabStatus,
  {className: string; iconName: IconName | null; localeLabelKey: string}
> = {
  [SAFE_COLLAB_STATUS.Vetted]: {
    className: 'vetted',
    iconName: 'Actions-Patch-Accept-Fill',
    localeLabelKey: 'Vetted',
  },
  [SAFE_COLLAB_STATUS.NotVetted]: {
    className: 'notVetted',
    iconName: null,
    localeLabelKey: 'Not Vetted',
  },
  [SAFE_COLLAB_STATUS.Warning]: {
    className: 'warning',
    iconName: 'Navigation-Attention',
    localeLabelKey: 'Vetted',
  },
};

const BadgeContainer = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
});

interface SafeCollabBadgeProps {
  status: SafeCollabStatus;
}

function SafeCollabBadge({status}: SafeCollabBadgeProps) {
  const config = BADGE_CONFIG[status];

  return (
    <BadgeContainer className={`${styles.badge} ${styles[config.className]}`}>
      {config.iconName !== null && (
        <Icon size="small" appearance="neutral" name={config.iconName} />
      )}
      <Body size="sm">{translate(config.localeLabelKey)}</Body>
    </BadgeContainer>
  );
}

export default SafeCollabBadge;
